import { axiosUtils } from "../../network/axiosUtils";
import httpRequest from "../../network/httpRequest";
import { HttpResponse } from "../../network/types";
import { ChangeRepairShopAccountResponse } from "./types/SelectDto";

const url = "/repair-shop-master/select";

/**
 * 마스터 계정 매장 변환 처리 (token)
 * @param id
 * @returns
 */
export const postChangeRepairshopAccount = async (
  id: number
): Promise<ChangeRepairShopAccountResponse> => {
  if (id <= 0) throw new Error("error");
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `${url}/${id}`,
  });

  const res: ChangeRepairShopAccountResponse = {
    admin: response?.data.row,
    accessToken:
      response?.headers.Authorization || response?.headers.authorization,
  };

  return res;
};
